











import { Component, Vue } from "vue-property-decorator";

@Component
export default class NavigationListMobile extends Vue {
    public get items(): {
        icon: string;
        title: string;
        link: string;
        permission: boolean;
    }[] {
        return [
            {
                icon: "mdi-home",
                title: this.$t("navigation.home") as string,
                link: "/",
                permission: true,
            },
            {
                icon: "mdi-collage",
                title: this.$t("navigation.studios") as string,
                link: "/studios",
                permission: true,
            },
            {
                icon: "mdi-film",
                title: this.$t("navigation.script") as string,
                link: "/script",
                permission: true,
            },
            {
                icon: "mdi-chart-box",
                title: this.$t("navigation.reports") as string,
                link: "/reports",
                permission: true,
            },
            {
                icon: "mdi-calendar",
                title: this.$t("navigation.events") as string,
                link: "/events",
                permission: true,
            },
            {
                icon: "mdi-account",
                title: this.$t("navigation.home") as string,
                link: "/profile",
                permission: this.$store.state.user?.permissions.includes(
                    "eventplanner"
                ),
            },
        ];
    }
    public get availableItems() {
        return this.items.filter(i => i.permission);
    }
}
